"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedRefundResponseExceptPayment = exports.mockedRefundResponse = void 0;
const refund_1 = require("../../dto/refund");
const omit_util_1 = require("../../utils/omit.util");
const payment_1 = require("../payment");
const refund_cart_item_1 = require("../refund-cart-item");
exports.mockedRefundResponse = {
  id: 1,
  createdAt: new Date(),
  updatedAt: null,
  reason: 'Broken',
  sentAt: null,
  refundedAt: null,
  payment: payment_1.mockedPaymentResponse,
  cart: [refund_cart_item_1.mockedRefundCartItemResponseExceptRefund],
  status: refund_1.RefundStatus.PENDING,
  externalRefundId: 'qwerty',
  externalRefundToken: 'qwerty',
  oldId: null
};
exports.mockedRefundResponseExceptPayment = omit_util_1.omitObject(exports.mockedRefundResponse, 'payment');